var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useState, useEffect, useMemo, useRef, } from "react";
import { Frame } from "framer";
import styled from "styled-components";
import designTheme from "../../designSystem/theme";
import colors from "../../designSystem/colors";
import { Subtitle } from "../../designSystem";
import useElementScroll from "../../hooks/useElementScroll";
import useElementSize from "../../hooks/useElementSize";
var SegmentControlContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: ", ";\n  background-color: ", ";\n  display: flex;\n  position: relative;\n\n  ", "\n\n  ", "\n\n  overflow-y: auto;\n\n  /* Firefox */\n  scrollbar-width: none;\n\n  /* Chrome, Edge, and Safari */\n  &::-webkit-scrollbar {\n    height: 0px;\n  }\n"], ["\n  border-radius: ", ";\n  background-color: ", ";\n  display: flex;\n  position: relative;\n\n  ", "\n\n  ", "\n\n  overflow-y: auto;\n\n  /* Firefox */\n  scrollbar-width: none;\n\n  /* Chrome, Edge, and Safari */\n  &::-webkit-scrollbar {\n    height: 0px;\n  }\n"])), function (_a) {
    var hideBorderRadius = _a.hideBorderRadius;
    return hideBorderRadius ? "0" : designTheme.border.radius;
}, function (props) {
    if (props.theme === "plain") {
        return "transparent";
    }
    if (props.backgroundColor) {
        return props.backgroundColor;
    }
    if (props.color) {
        return props.color + "14";
    }
    return colors.background.two;
}, function (props) {
    switch (props.theme) {
        case "outline":
            return "";
        default:
            return "padding: 8px;";
    }
}, function (props) {
    switch (props.widthType) {
        case "fullWidth":
            return "\n          flex: 1;\n        ";
        case "maxContent":
            return "";
    }
});
var ContainerScrollIndicator = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  ", "\n  position: absolute;\n  height: 60px;\n  width: 48px;\n  justify-content: center;\n  align-items: center;\n  background: linear-gradient(270deg, #08090e 40.63%, rgba(8, 9, 14, 0) 100%);\n  border-radius: ", ";\n  z-index: 2;\n  transition: 0.2s all ease-out;\n  top: 0;\n  ", "\n"], ["\n  display: flex;\n  ", "\n  position: absolute;\n  height: 60px;\n  width: 48px;\n  justify-content: center;\n  align-items: center;\n  background: linear-gradient(270deg, #08090e 40.63%, rgba(8, 9, 14, 0) 100%);\n  border-radius: ", ";\n  z-index: 2;\n  transition: 0.2s all ease-out;\n  top: 0;\n  ", "\n"])), function (props) {
    return props.show
        ? "\n          opacity: 1;\n        "
        : "\n          opacity: 0;\n          visibility: hidden;\n        ";
}, designTheme.border.radius, function (props) {
    switch (props.direction) {
        case "left":
            return "\n          left: 0;\n          transform: rotate(-180deg);\n        ";
        case "right":
            return "\n          right: 0;\n        ";
    }
});
var IndicatorIcon = styled.i(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: white;\n"], ["\n  color: white;\n"])));
var ActiveBackground = styled(Frame)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border-radius: ", " !important;\n  ", "\n"], ["\n  border-radius: ", " !important;\n  ", "\n"])), designTheme.border.radius, function (props) {
    switch (props.theme) {
        case "outline":
            return "\n          transition: 0.25s border ease-out;\n          border: " + designTheme.border.width + " " + designTheme.border.style + " \n            " + (props.color ? props.color : colors.primaryText) + ";\n          background-color: transparent !important;\n        ";
        case "plain":
            return "\n          background-color: transparent !important;\n        ";
        default:
            return "\n          transition: 0.35s background-color ease-out;\n          background-color: " + (props.color ? props.color : colors.primaryText) + "1F !important;\n        ";
    }
});
var SegmentControlButton = styled.div.attrs({
    className: "d-flex align-items-center justify-content-center",
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding: ", ";\n  z-index: 1;\n  margin-right: ", ";\n\n  &:last-child {\n    margin-right: 0px;\n  }\n\n  ", "\n"], ["\n  padding: ", ";\n  z-index: 1;\n  margin-right: ", ";\n\n  &:last-child {\n    margin-right: 0px;\n  }\n\n  ", "\n"])), function (props) { return props.py + "px " + props.px + "px"; }, function (props) { return (props.spacingBetweenButtons ? "4px" : "0"); }, function (props) {
    switch (props.widthType) {
        case "fullWidth":
            return "\n          display: flex;\n          flex: 1;\n          justify-content: center;\n        ";
        case "maxContent":
            return "";
    }
});
var SegmentControlButtonText = styled(Subtitle)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  letter-spacing: 1px;\n  white-space: nowrap;\n\n  ", "\n"], ["\n  letter-spacing: 1px;\n  white-space: nowrap;\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme, active = _a.active;
    if (theme === "plain") {
        return "opacity: " + (active ? 1 : 0.48) + ";";
    }
    return "";
});
var SegmentControl = function (_a) {
    var segments = _a.segments, value = _a.value, onSelect = _a.onSelect, _b = _a.config, _c = _b === void 0 ? {} : _b, theme = _c.theme, color = _c.color, backgroundColor = _c.backgroundColor, _d = _c.widthType, widthType = _d === void 0 ? "maxContent" : _d, _e = _c.button, button = _e === void 0 ? { px: 16, py: 12, fontSize: 14, lineHeight: 24 } : _e, hideBorderRadius = _c.hideBorderRadius;
    var controlRefs = useMemo(function () {
        return segments.reduce(function (acc, curr) {
            acc[curr.value] = React.createRef();
            return acc;
        }, {});
    }, [segments]);
    var _f = useState(false), activeBackgroundState = _f[0], setActiveBackgroundState = _f[1];
    var containerRef = useRef(null);
    var scrollY = useElementScroll(containerRef).scrollY;
    var width = useElementSize(containerRef).width;
    useEffect(function () {
        var currentCurrency = controlRefs[value].current;
        if (!currentCurrency) {
            return;
        }
        var handleResize = function () {
            setActiveBackgroundState({
                left: currentCurrency.offsetLeft,
                top: currentCurrency.offsetTop,
                height: currentCurrency.clientHeight,
                width: theme === "outline"
                    ? currentCurrency.clientWidth - 1
                    : currentCurrency.clientWidth,
            });
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return function () {
            window.removeEventListener("resize", handleResize);
        };
    }, [value, controlRefs, theme]);
    var handleScrollLeft = useCallback(function () {
        var _a;
        (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.scrollBy({ left: -width, behavior: "smooth" });
    }, [width]);
    var handleScrollRight = useCallback(function () {
        var _a;
        (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.scrollBy({ left: width, behavior: "smooth" });
    }, [width]);
    return (_jsxs(_Fragment, { children: [_jsxs(SegmentControlContainer, __assign({ ref: containerRef, theme: theme, color: color, backgroundColor: backgroundColor, widthType: widthType, hideBorderRadius: hideBorderRadius }, { children: [_jsx(ActiveBackground, { transition: {
                            type: "keyframes",
                            ease: "easeOut",
                        }, initial: {
                            height: "100%",
                            width: 0,
                        }, animate: activeBackgroundState, theme: theme, color: color }, void 0), segments.map(function (segment) {
                        var _a;
                        return (_jsx(SegmentControlButton, __assign({ role: "button", onClick: function () { return onSelect(segment.value); }, ref: controlRefs[segment.value], widthType: widthType, px: button.px, py: button.py, spacingBetweenButtons: theme !== "outline" }, { children: _jsx(SegmentControlButtonText, __assign({ theme: theme, active: segment.value === value, color: (_a = segment.textColor) !== null && _a !== void 0 ? _a : color, fontSize: button.fontSize, lineHeight: button.lineHeight }, { children: segment.display }), void 0) }), segment.value));
                    })] }), void 0), _jsx(ContainerScrollIndicator, __assign({ direction: "left", show: scrollY.left > 5, role: "button", onClick: handleScrollLeft }, { children: _jsx(IndicatorIcon, { className: "fas fa-chevron-right" }, void 0) }), void 0), _jsx(ContainerScrollIndicator, __assign({ direction: "right", show: scrollY.right > 5, role: "button", onClick: handleScrollRight }, { children: _jsx(IndicatorIcon, { className: "fas fa-chevron-right" }, void 0) }), void 0)] }, void 0));
};
export default SegmentControl;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=SegmentControl.js.map